import * as api from "../../services/api";
import {useQuery} from "@tanstack/react-query";


export const useBookingVariantsQuery = (dateFromISO, dateToISO, nPeople, petsNumber, homeId) => {
    let queryKey = ["bookingVariants", dateFromISO, dateToISO, nPeople, petsNumber];
    if (homeId !== null && homeId !== undefined){
        queryKey = [...queryKey, homeId];
    }
    return useQuery({
            queryKey: queryKey,
            queryFn: async () => api.RatesAPI.getBookingVariants(dateFromISO, dateToISO, nPeople, petsNumber, homeId),
            enabled: !!dateFromISO && !!dateToISO && dateToISO > dateFromISO && nPeople > 0 && petsNumber >= 0
        }
    )
}

export const useRequestQuery = (requestId) => {
    return useQuery({
        queryKey: ["requests", requestId],
        queryFn: async () => api.RequestsAPI.getRequest(requestId),
        enabled: requestId !== null && requestId !== undefined
    })
}